var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.appComponent,{tag:"component"}),_c('confirm-dialog',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }